import {Box, Button, Divider, HStack, useToken} from '@chakra-ui/react';
import {useColorModeValueKey, useReadableTextColor} from 'hooks/useColors';
import React from 'react';

const BtnGroup = (props = {}) => {
    const {
        btns = [],
        onSelect,
        selected,
        disabled,
        nullable = false,
        variant = 'solid',
        fontSize,
        ...others
    } = props;


    const grayColor = useColorModeValueKey('gray');
    const whiteColor = useColorModeValueKey('brighterBg');
    const borderColor = useColorModeValueKey('border');
    const primaryColor = useColorModeValueKey('primary');
    const selectedTextColor = useReadableTextColor(
        useToken('colors', primaryColor),
    );
    return (
        <HStack
            borderColor={borderColor}
            borderWidth={1}
            borderStyle="solid"
            rounded={'md'}
            overflow="hidden"
            divider={<Divider orientation="vertical" />}
            spacing={0}
            {...others}
        >
            {btns.map((item) => (
                <Button
                    rounded={'none'}
                    variant={'unstyled'}
                    size="sm"
                    key={item.value}
                    onClick={() =>
                        onSelect(
                            nullable && item.value === selected
                                ? null
                                : item.value,
                        )
                    }
                    flex={1}
                    isDisabled={disabled || item.disabled}
                    bg={
                        selected === item.value
                            ? primaryColor
                            : variant === 'filled'
                            ? 'muted.100'
                            : whiteColor
                    }
                    color={
                        selected === item.value ? selectedTextColor : grayColor
                    }
                >
                    {item.label}
                </Button>
            ))}
        </HStack>
    );
};

export default BtnGroup;
